import { render, staticRenderFns } from "./ClientMetaApplication.vue?vue&type=template&id=45689502&"
import script from "./ClientMetaApplication.vue?vue&type=script&lang=ts&"
export * from "./ClientMetaApplication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports